import {
  getBasicDetailsDropdownList,
  getManagePredictorToolsFilterData,
  getPredictorToolsListingData,
  getBasicToolsDetailsRepo,
  postBasicToolsDetailsRepo,
  getInputPageDetailRepo,
  postInputPageDetailRepo,
  getInputPageToolContentRepo,
  postInputPageToolContentRepo,
  getInputPageFaqContentRepo,
  postInputPageFaqContentRepo,
  getResultPageRepo,
  postResultPageRepo,
} from '../../repositories/tools/CP_PedictorTools'
import {
  fetchBasicDetailDropdownListError,
  fetchBasicDetailDropdownListSuccess,
  fetchFilterDataError,
  fetchFilterDataSuccess,
  fetchListingDataError,
  fetchListingDataSuccess,
  loadingBasicDetailDropdownList,
  loadingFilterData,
  loadingListingData,
  getPredictorToolTypeLoading,
  getPredictorToolTypeSuccess,
  getPredictorToolTypeFailure,
  getPredictorExamDropdownLoading,
  getPredictorExamDropdownSuccess,
  getPredictorExamDropdownFailure,
  getBasicDetailLoading,
  getBasicDetailSuccess,
  getBasicDetailFailure,
  postBasicDetailLoading,
  postBasicDetailSuccess,
  postBasicDetailFailure,
  getInputDetailLoading,
  getInputDetailSuccess,
  getInputDetailFailure,

  postInputDetailLoading,
  postInputDetailSuccess,
  postInputDetailFailure,

  getInputToolContentLoading,
  getInputToolContentSuccess,
  getInputToolContentFailure,

  postInputToolContentLoading,
  postInputToolContentSuccess,
  postInputToolContentFailure,

  getInputPageFaqLoading,
  getInputPageFaqSuccess,
  getInputPageFaqFailure,

  postInputPageFaqLoading,
  postInputPageFaqSuccess,
  postInputPageFaqFailure,

  getResultPageLoading,
  getResultPageSuccess,
  getResultPageFailure,

  postResultPageLoading,
  postResultPageSuccess,
  postResultPageFailure,

  getPredictorToolNameLoading,
  getPredictorToolNameSuccess,
  getPredictorToolNameFailure,

  getPredictorToolDomainLoading,
  getPredictorToolDomainSuccess,
  getPredictorToolDomainFailure,

  getPredictorToolAuthorLoading,
  getPredictorToolAuthorSuccess,
  getPredictorToolAuthorFailure,
  clearPredictorToolAuthorResponse,
  clearPostBasicDetailMessageResponse,
} from '../../slices/managePredictorTools'

export const fetchPredictorToolsFilterData = (params) => {
  return async (dispatch) => {
    dispatch(loadingFilterData())
    try {
      const response = await getManagePredictorToolsFilterData(params)
      if (response.status === 200) {
        dispatch(
          fetchFilterDataSuccess({
            data: response?.data?.data,
          })
        )
      } else {
        dispatch(fetchFilterDataError(response?.message))
      }
    } catch (error) {
      dispatch(fetchFilterDataError(error.message))
    }
  }
}

export const fetchPredictorToolsListingData = (params) => {
  return async (dispatch) => {
    dispatch(loadingListingData())
    try {
      const response = await getPredictorToolsListingData(params)
      if (response.status === 200) {
        dispatch(
          fetchListingDataSuccess({
            data: response?.data?.data,
          })
        )
      } else {
        dispatch(fetchBasicDetailDropdownListError(response?.message))
      }
    } catch (error) {
      dispatch(fetchBasicDetailDropdownListError(error.message))
    }
  }
}

export const getBasicDetailDropdownData = (params) => {
  return async (dispatch) => {
    dispatch(loadingBasicDetailDropdownList())
    try {
      const response = await getBasicDetailsDropdownList(params)
      if (response.status === 200) {
        dispatch(
          fetchBasicDetailDropdownListSuccess({
            data: response?.data?.data,
          })
        )
      } else {
        dispatch(fetchFilterDataError(response?.message))
      }
    } catch (error) {
      dispatch(fetchBasicDetailDropdownListError(error.message))
    }
  }
}

export const getPredictorToolName = (params) => {
  return async (dispatch) => {
    dispatch(getPredictorToolNameLoading())
    await getBasicDetailsDropdownList(params)
      .then((response) => {
        if (response?.status >= 200 && response?.status <= 300) {
          dispatch(getPredictorToolNameSuccess(response?.data?.data))
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getPredictorToolNameFailure(error.message))
        }
      })
  }
}

export const getPredictorToolDomain = (params) => {
  return async (dispatch) => {
    dispatch(getPredictorToolDomainLoading())
    await getBasicDetailsDropdownList(params)
      .then((response) => {
        if (response?.status >= 200 && response?.status <= 300) {
          dispatch(getPredictorToolDomainSuccess(response?.data?.data))
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getPredictorToolDomainFailure(error.message))
        }
      })
  }
}

export const getPredictorToolType = (params) => {
  return async (dispatch) => {
    dispatch(getPredictorToolTypeLoading())
    await getBasicDetailsDropdownList(params)
      .then((response) => {
        if (response?.status >= 200 && response?.status <= 300) {
          dispatch(getPredictorToolTypeSuccess(response?.data?.data))
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getPredictorToolTypeFailure(error.message))
        }
      })
  }
}

export const getPredictorExamDropdown = (params) => {
  return async (dispatch) => {
    dispatch(getPredictorExamDropdownLoading())
    await getBasicDetailsDropdownList(params)
      .then((response) => {
        if (response?.status >= 200 && response?.status <= 300) {
          dispatch(getPredictorExamDropdownSuccess(response?.data?.data))
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getPredictorExamDropdownFailure(error.message))
        }
      })
  }
}
export const getPredictorToolAuthor = (params) => {
  return async (dispatch) => {
    dispatch(getPredictorToolAuthorLoading())
    await getBasicDetailsDropdownList(params)
      .then((response) => {
        if (response?.status >= 200 && response?.status <= 300) {
          dispatch(getPredictorToolAuthorSuccess(response?.data?.data))
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getPredictorToolAuthorFailure(error.message))
        }
      })
  }
}

export const getBasicDetails = (params) => {
  return async (dispatch) => {
    dispatch(getBasicDetailLoading())
    await getBasicToolsDetailsRepo(params)
      .then((response) => {
        if (response?.status >= 200 && response?.status <= 300) {
          dispatch(getBasicDetailSuccess(response?.data?.data))
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getBasicDetailFailure(error.message))
        }
      })
  }
}

export const postBasicDetails = (data) => {
  return async (dispatch) => {
    dispatch(postBasicDetailLoading())
    await postBasicToolsDetailsRepo(data)
      .then((response) => {
        if (response?.status >= 200 && response?.status <= 300) {
          dispatch(postBasicDetailSuccess(response?.data?.data))
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(postBasicDetailFailure(error?.response?.data))
        }
      })
      .finally(() => {
        setTimeout(() => {
          dispatch(clearPostBasicDetailMessageResponse());
        }, 2000);
      });
  }
}

//get input page detail action
export const getInputPageDetails = (params) => {
  return async (dispatch) => {
    dispatch(getInputDetailLoading())
    await getInputPageDetailRepo(params)
      .then((response) => {
        if (response?.status >= 200 && response?.status <= 300) {
          dispatch(getInputDetailSuccess(response?.data?.data))
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getInputDetailFailure(error.message))
        }
      })
  }
}

export const postInputPageDetails = (data) => {
  return async (dispatch) => {
    dispatch(postInputDetailLoading())
    await postInputPageDetailRepo(data)
      .then((response) => {
        if (response?.status >= 200 && response?.status <= 300) {
          dispatch(postInputDetailSuccess(response?.data?.data))
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(postInputDetailFailure(error.message))
        }
      })
  }
}


//get input tool content
export const getInputPageToolContent = (params) => {
  return async (dispatch) => {
    dispatch(getInputToolContentLoading())
    await getInputPageToolContentRepo(params)
      .then((response) => {
        if (response?.status >= 200 && response?.status <= 300) {
          dispatch(getInputToolContentSuccess(response?.data?.data))
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getInputToolContentFailure(error.message))
        }
      })
  }
}

export const postInputPageToolContent = (data) => {
  return async (dispatch) => {
    dispatch(postInputToolContentLoading())
    await postInputPageToolContentRepo(data)
      .then((response) => {
        if (response?.status >= 200 && response?.status <= 300) {
          dispatch(postInputToolContentSuccess(response?.data?.data))
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(postInputToolContentFailure(error.message))
        }
      })
  }
}

//get input faq content
export const getInputPageFaqContent = (params) => {
  return async (dispatch) => {
    dispatch(getInputPageFaqLoading())
    await getInputPageFaqContentRepo(params)
      .then((response) => {
        if (response?.status >= 200 && response?.status <= 300) {
          dispatch(getInputPageFaqSuccess(response?.data?.data))
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getInputPageFaqFailure(error.message))
        }
      })
  }
}

export const postInputPageFaqContent = (data) => {
  return async (dispatch) => {
    dispatch(postInputPageFaqLoading())
    await postInputPageFaqContentRepo(data)
      .then((response) => {
        if (response?.status >= 200 && response?.status <= 300) {
          dispatch(postInputPageFaqSuccess(response?.data?.data))
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(postInputPageFaqFailure(error.message))
        }
      })
  }
}

//manage result page
export const getResultPage = (params) => {
  return async (dispatch) => {
    dispatch(getResultPageLoading())
    await getResultPageRepo(params)
      .then((response) => {
        if (response?.status >= 200 && response?.status <= 300) {
          dispatch(getResultPageSuccess(response?.data?.data))
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getResultPageFailure(error.message))
        }
      })
  }
}

export const postResultPage = (data) => {
  return async (dispatch) => {
    dispatch(postResultPageLoading())
    await postResultPageRepo(data)
      .then((response) => {
        if (response?.status >= 200 && response?.status <= 300) {
          dispatch(postResultPageSuccess(response?.data?.data))
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(postResultPageFailure(error.message))
        }
      })
  }
}